export default __webpack_public_path__ + "static/media/Internal-Project.459973c9.png";